import React from 'react';
import {Checkbox} from 'antd';
import commonExtendsHOC from '../../commonExtendsHOC';

const {Group} =Checkbox;
export default commonExtendsHOC(Checkbox);
export const AisinoCheckboxGroup=commonExtendsHOC(Group);
